export default "__VITE_PUBLIC_ASSET__eefa7252__"